import { error } from 'reducers/errors';
import account from 'reducers/account/account';
import address from 'store/ducks/address/reducer';
import ads from 'reducers/ads';
import amazonReverseSharing from 'reducers/amazonReverseSharing';
import amethyst from 'reducers/amethyst';
import ask from 'reducers/ask/ask';
import authentication from 'reducers/authentication';
import autoComplete from 'reducers/autoComplete';
import autofacet from 'reducers/autofacet';
import badges from 'reducers/badges';
import brandPage from 'reducers/brand/brandPage';
import cart from 'reducers/cart/cart';
import checkoutData from 'store/ducks/checkout/reducer';
import client from 'reducers/client';
import cookies from 'reducers/cookies';
import customer from 'reducers/customer';
import deviceProps from 'store/ducks/deviceProps/reducer';
import drop from 'reducers/drop';
import eGiftCards from 'reducers/eGiftCards';
import emergencyBanner from 'store/ducks/emergencyBanner/reducer';
import environmentConfig from 'reducers/environmentConfig';
import exchange from 'reducers/account/exchange';
import exchangesData from 'store/ducks/exchanges/reducer';
import facets, { isFacetsVisible } from 'reducers/search/facets';
import facetsV2 from 'reducers/search/facetsV2';
import feedback from 'store/ducks/feedback/reducer';
import filters from 'reducers/search/filters';
import giftOptions from 'store/ducks/giftoptions/reducer';
import headerFooter from 'reducers/headerfooter';
import hearts from 'reducers/hearts';
import history from 'store/ducks/history/reducer';
import hmdSurvey from 'reducers/ask/hmdSurvey';
import holmes from 'reducers/holmes';
import iframe from 'reducers/landing/iframe';
import killswitch from 'store/ducks/killswitch/reducer';
import landingPage from 'reducers/landing/landingPage';
import localStorage from 'reducers/localStorage';
import meta from 'reducers/meta';
import microsoftUetTag from 'reducers/microsoftUetTag';
import newsfeed from 'reducers/landing/newsfeed';
import order from 'reducers/account/order';
import orders from 'reducers/account/orders';
import pageLoad from 'reducers/pageLoad';
import pageView from 'reducers/pageView';
import payment from 'reducers/account/payment';
import pixelServer from 'reducers/pixelServer';
import product from 'reducers/detail/productDetail';
import products from 'reducers/search/products';
import recos from 'reducers/recos';
import redirect from 'reducers/redirect';
import responseCookies from 'reducers/responseCookies';
import returns from 'reducers/account/returns';
import reviews from 'reducers/reviews/reviews';
import rewards from 'reducers/account/rewards';
import search from 'store/ducks/search/reducer';
import searchLayout from 'reducers/search/searchLayout';
import sharedPayment from 'store/ducks/payment/reducer';
import sharedRewards from 'store/ducks/rewards/reducer';
import sharing from 'reducers/detail/sharing';
import shipmentTracking from 'reducers/shipmentTracking';
import shipOption from 'store/ducks/shipOption/reducer';
import shipping from 'reducers/account/shipping';
import sizingChooser from 'reducers/detail/sizingChooser';
import subscriptionsInfo from 'reducers/subscriptionsInfo';
import unleash from 'reducers/unleash';
import wildCard from 'reducers/wildCard';
import zfcSessionId from 'reducers/zfcSessionId';

export default {
  account,
  address,
  ads,
  amazonReverseSharing,
  amethyst,
  ask,
  authentication,
  autoComplete,
  autofacet,
  badges,
  brandPage,
  cart,
  checkoutData,
  client,
  cookies,
  customer,
  deviceProps,
  drop,
  eGiftCards,
  emergencyBanner,
  environmentConfig,
  error,
  exchange,
  exchangesData,
  facets,
  facetsV2,
  feedback,
  filters,
  giftOptions,
  headerFooter,
  hearts,
  history,
  hmdSurvey,
  holmes,
  iframe,
  isFacetsVisible,
  killswitch,
  landingPage,
  localStorage,
  meta,
  microsoftUetTag,
  newsfeed,
  order,
  orders,
  pageLoad,
  pageView,
  payment,
  pixelServer,
  product,
  products,
  recos,
  redirect,
  responseCookies,
  returns,
  reviews,
  rewards,
  search,
  searchLayout,
  sharedPayment,
  sharedRewards,
  sharing,
  shipmentTracking,
  shipOption,
  shipping,
  sizingChooser,
  subscriptionsInfo,
  unleash,
  url: (state = {}) => state,
  wildCard,
  zfcSessionId
};
